import React, { Component } from 'react';
import { MapContainer, CircleMarker, FeatureGroup, Tooltip, LayersControl, TileLayer, Polyline } from 'react-leaflet'
import { latLngBounds } from 'leaflet'

// Assigned to a hole but NOT that hole's reported capture (no Summary.DiffvsPlan
// row, therefore no polyline) — distinct from the '#c9c9c9' grey used for
// assigned+reported captures.
const ORPHAN_CAPTURE_COLOR = '#a855f7';

export class GPSMapContainer extends Component {
    constructor(props) {
        super(props);

        var showPolyline = [];
        var lat1 = [];
        var long1 = [];
        var lat2 = [];
        var long2 = [];

        //Create refs
        this.captureCircleRefs = [];
        this.capturePolylineRefs = [];
        if (this.props.capturedataLoaded) {
            this.props.capturedata.map(row => {
                this.captureCircleRefs.push(React.createRef());
                this.capturePolylineRefs.push(React.createRef());
                showPolyline.push(false);
                lat1.push(0);
                long1.push(0);
                lat2.push(0);
                long2.push(0);
            });
        }

        this.missingCircleRefs = [];
        if (this.props.missingdataLoaded) {
            this.props.missingdata.map(row => {
                this.missingCircleRefs.push(React.createRef());

            });
        }
        this.planCircleRefs = [];
        if (this.props.plandataLoaded) {
            this.props.plandata.map(row => {
                this.planCircleRefs.push(React.createRef());
            });
        }

        var diffRemoved = [];

        this.diffCircleRefs = [];
        this.diffPolylineRefs = [];
        if (this.props.diffdataLoaded) {
            this.props.diffdata.map(row => {
                this.diffCircleRefs.push(React.createRef());
                this.diffPolylineRefs.push(React.createRef());
                diffRemoved.push(false);
            });
        }

        this.state = {
            //Init - config
            pageCaptureClickedIndex: -1,
            pageCaptureClickedData: {},
            pageMissingClickedIndex: -1,
            pageMissingClickedData: {},
            pagePlanClickedIndex: -1,
            pagePlanClickedData: {},
            pageCaptureShowPolyline: showPolyline,
            pageCaptureShowPolyline_Latitude1: lat1,
            pageCaptureShowPolyline_Longitude1: long1,
            pageCaptureShowPolyline_Latitude2: lat2,
            pageCaptureShowPolyline_Longitude2: long2,
            pageResetNextClick: false,
            pageDiffRemoved: diffRemoved,
            markerRadius: 8
        };
        this.handleZoom = this.handleZoom.bind(this);
        this._lastZoom = null;
        this._lastRadius = null;
        this._rafId = null;
    }

    getZoom(map = this.map) {
        return map?.getZoom?.() ?? this._lastZoom ?? 17;
    }

    computeRadius(z) {
        const baseZoom = 19;   // reference zoom
        const baseRadius = 4;    // radius at zoom 19
        const minPx = 3;
        const maxPx = 25;

        // factor so that radius doubles every 1.5 zoom levels
        const factor = Math.pow(2, 1 / 1.5);

        const r = baseRadius * Math.pow(factor, z - baseZoom);
        return Math.max(minPx, Math.min(maxPx, Math.round(r)));
    }

    handleZoom(e) {
        const map = e?.target || this.map;
        if (!map) return;

        // Cancel any pending animation frame to avoid stacking updates
        if (this._rafId) {
            cancelAnimationFrame(this._rafId);
        }

        // Use requestAnimationFrame to sync with browser paint cycle
        this._rafId = requestAnimationFrame(() => {
            const z = map.getZoom();
            const r = this.computeRadius(z);

            // Only update if radius actually changed (avoids unnecessary re-renders)
            if (r !== this._lastRadius) {
                this._lastZoom = z;
                this._lastRadius = r;
                this.setState({ markerRadius: r });
            }
            this._rafId = null;
        });
    }

    componentWillUnmount() {
        if (this._rafId) {
            cancelAnimationFrame(this._rafId);
        }
        if (this.map) {
            this.map.off('zoom', this.handleZoom);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.capturedata != prevProps.capturedata || this.props.missingdata != prevProps.missingdata || this.props.plandata != prevProps.plandata || this.props.diffdata != prevProps.diffdata) { //re-init
            var showPolyline = [];
            var lat1 = [];
            var long1 = [];
            var lat2 = [];
            var long2 = [];

            //Create refs
            this.captureCircleRefs = [];
            this.capturePolylineRefs = [];
            if (this.props.capturedataLoaded) {
                this.props.capturedata.map(row => {
                    this.captureCircleRefs.push(React.createRef());
                    this.capturePolylineRefs.push(React.createRef());
                    showPolyline.push(false);
                    lat1.push(0);
                    long1.push(0);
                    lat2.push(0);
                    long2.push(0);
                });
            }
            this.missingCircleRefs = [];
            this.missingPolylineRefs = [];
            if (this.props.missingdataLoaded) {
                this.props.missingdata.map(row => {
                    this.missingCircleRefs.push(React.createRef());
                });
            }
            this.planCircleRefs = [];
            if (this.props.plandataLoaded) {
                this.props.plandata.map(row => {
                    this.planCircleRefs.push(React.createRef());
                });
            }

            var diffRemoved = [];

            this.diffCircleRefs = [];
            this.diffPolylineRefs = [];
            if (this.props.diffdataLoaded) {
                this.props.diffdata.map(row => {
                    this.diffCircleRefs.push(React.createRef());
                    this.diffPolylineRefs.push(React.createRef());
                    diffRemoved.push(false);
                });
            }

            this.setState({
                //Init - config
                pageCaptureClickedIndex: -1,
                pageCaptureClickedData: {},
                pageMissingClickedIndex: -1,
                pageMissingClickedData: {},
                pagePlanClickedIndex: -1,
                pagePlanClickedData: {},
                pageCaptureShowPolyline: showPolyline,
                pageCaptureShowPolyline_Latitude1: lat1,
                pageCaptureShowPolyline_Longitude1: long1,
                pageCaptureShowPolyline_Latitude2: lat2,
                pageCaptureShowPolyline_Longitude2: long2,
                pageResetNextClick: false,
                pageDiffRemoved: diffRemoved
            });
        }

        if (!this.props.selectionModeEnabled && prevProps.selectionModeEnabled) {
            var showPolyline = [];
            var lat1 = [];
            var long1 = [];
            var lat2 = [];
            var long2 = [];

            //Update refs where required
            if (this.props.capturedataLoaded) {
                this.props.capturedata.map((row, index) => {
                    if (this.captureCircleRefs[index].current != null) {
                        this.captureCircleRefs[index].current.setStyle(this.pathStyle(this.props.styleMap.HoleData_Captured) || { fillOpacity: 0.2, fillColor: 'green' })
                    }
                    showPolyline.push(false);
                    lat1.push(0);
                    long1.push(0);
                    lat2.push(0);
                    long2.push(0);
                });
            }
            if (this.props.missingdataLoaded) {
                this.props.missingdata.map((row, index) => {
                    if (this.missingCircleRefs[index].current != null) {
                        this.missingCircleRefs[index].current.setStyle(this.pathStyle(this.props.styleMap.HoleData_Missing) || { fillOpacity: 0.2, fillColor: 'red' })
                    }
                });
            }
            if (this.props.plandataLoaded) {
                this.props.plandata.map((row, index) => {
                    if (this.planCircleRefs[index].current != null) {
                        this.planCircleRefs[index].current.setStyle(this.pathStyle(this.props.styleMap.HoleData_Plan) || { fillOpacity: 0.2, fillColor: 'grey' })
                    }
                });
            }

            var diffRemoved = [];
            if (this.props.diffdataLoaded) {
                this.props.diffdata.map(row => {
                    diffRemoved.push(false);
                });
            }

            this.setState({
                //Init - config
                pageCaptureClickedIndex: -1,
                pageCaptureClickedData: {},
                pageMissingClickedIndex: -1,
                pageMissingClickedData: {},
                pagePlanClickedIndex: -1,
                pagePlanClickedData: {},
                pageCaptureShowPolyline: showPolyline,
                pageCaptureShowPolyline_Latitude1: lat1,
                pageCaptureShowPolyline_Longitude1: long1,
                pageCaptureShowPolyline_Latitude2: lat2,
                pageCaptureShowPolyline_Longitude2: long2,
                pageResetNextClick: false,
                pageDiffRemoved: diffRemoved
            });
        }
    }

    overrideColorsForSelection(capturedataIndex, capturedataData, missingdataIndex, missingdataData, plandataIndex, plandataData) {
        var showPolyline = this.state.pageCaptureShowPolyline;
        var lat1 = this.state.pageCaptureShowPolyline_Latitude1;
        var long1 = this.state.pageCaptureShowPolyline_Longitude1;
        var lat2 = this.state.pageCaptureShowPolyline_Latitude2;
        var long2 = this.state.pageCaptureShowPolyline_Longitude2;

        //Mark clicked black
        if (capturedataIndex >= 0) {
            if (this.state.pageCaptureClickedIndex != null) {
                if ((this.state.pageCaptureClickedIndex != capturedataIndex) && (this.state.pageCaptureClickedIndex >= 0)) {
                    //Set old one back to original color
                    this.captureCircleRefs[this.state.pageCaptureClickedIndex].current.setStyle(this.pathStyle(this.props.styleMap.HoleData_Captured) || { fillOpacity: 0.2, fillColor: 'green' })
                }
            }
            this.captureCircleRefs[capturedataIndex].current.setStyle(this.pathStyle(this.props.styleMap.Review_Clicked) || { fillOpacity: 1, fillColor: 'black' })
        }

        if (missingdataIndex >= 0) {
            if (this.state.pageMissingClickedIndex != null) {
                if ((this.state.pageMissingClickedIndex != missingdataIndex) && (this.state.pageMissingClickedIndex >= 0)) {
                    //Set old one back to original color
                    this.missingCircleRefs[this.state.pageMissingClickedIndex].current.setStyle(this.pathStyle(this.props.styleMap.HoleData_Missing) || { fillOpacity: 0.2, fillColor: 'red' })
                }
            }
            this.missingCircleRefs[missingdataIndex].current.setStyle(this.pathStyle(this.props.styleMap.Review_Clicked) || { fillOpacity: 1, fillColor: 'black' })
        } else if (plandataIndex >= 0) {
            if (this.state.pagePlanClickedIndex != null) {
                if ((this.state.pagePlanClickedIndex != plandataIndex) && (this.state.pagePlanClickedIndex >= 0)) {
                    //Set old one back to original color
                    this.planCircleRefs[this.state.pagePlanClickedIndex].current.setStyle(this.pathStyle(this.props.styleMap.HoleData_Plan) || { fillOpacity: 0.2, fillColor: 'grey' })
                }
            }
            this.planCircleRefs[plandataIndex].current.setStyle(this.pathStyle(this.props.styleMap.Review_Clicked) || { fillOpacity: 1, fillColor: 'black' })
        }

        if ((capturedataIndex >= 0) && ((missingdataIndex >= 0) || (plandataIndex >= 0))) {
            if (this.capturePolylineRefs[capturedataIndex].current != null) {
                this.capturePolylineRefs[capturedataIndex].current.setStyle(this.pathStyle(this.props.styleMap.Review_Clicked) || { fillOpacity: 1, fillColor: 'black' }) //done need to switch off as isnt shown
            }
            lat1[capturedataIndex] = capturedataData.Latitude;
            long1[capturedataIndex] = capturedataData.Longitude;
            if (missingdataIndex >= 0) {
                lat2[capturedataIndex] = missingdataData.Latitude;
                long2[capturedataIndex] = missingdataData.Longitude;
            } else if (plandataIndex >= 0) {
                lat2[capturedataIndex] = plandataData.Latitude;
                long2[capturedataIndex] = plandataData.Longitude;
            }
            showPolyline[capturedataIndex] = true;
        } else {
            // No longer show polyline for the previously selected capture (if any)
            if (this.state.pageCaptureClickedIndex >= 0) {
                showPolyline[this.state.pageCaptureClickedIndex] = false;
            }
        }

        //Mark previous array brown
        var index;
        if (this.props.selectionModeEnabled) {
            for (var i = 0; i < this.props.selectionModeSelections.length; i++) {
                index = this.props.selectionModeSelections[i]['capture_rowIndex'];
                if ((index != null) && (index >= 0)) {
                    this.captureCircleRefs[index].current.setStyle(this.pathStyle(this.props.styleMap.Review_ClickedPrevious) || { fillOpacity: 1, fillColor: 'brown' })
                    if (this.capturePolylineRefs[index].current != null) {
                        this.capturePolylineRefs[index].current.setStyle(this.pathStyle(this.props.styleMap.Previous) || { fillOpacity: 1, fillColor: 'brown' }) //done need to switch off as isnt shown
                    }
                    lat1[index] = this.props.selectionModeSelections[i]["capture_rowData"].Latitude;
                    long1[index] = this.props.selectionModeSelections[i]["capture_rowData"].Longitude;
                    if (this.props.selectionModeSelections[i]['missing_rowIndex'] != null) {
                        lat2[index] = this.props.selectionModeSelections[i]["missing_rowData"].Latitude;
                        long2[index] = this.props.selectionModeSelections[i]["missing_rowData"].Longitude;
                    } else if (this.props.selectionModeSelections[i]['plan_rowIndex'] != null) {
                        lat2[index] = this.props.selectionModeSelections[i]["plan_rowData"].Latitude;
                        long2[index] = this.props.selectionModeSelections[i]["plan_rowData"].Longitude;
                    }
                    showPolyline[index] = true;
                }

                if (this.props.selectionModeSelections[i]['missing_rowIndex'] != null) {
                    index = this.props.selectionModeSelections[i]['missing_rowIndex'];
                    if ((index != null) && (index >= 0)) {
                        this.missingCircleRefs[index].current.setStyle(this.pathStyle(this.props.styleMap.Review_ClickedPrevious) || { fillOpacity: 1, fillColor: 'brown' })
                    }
                } else if (this.props.selectionModeSelections[i]['plan_rowIndex'] != null) {
                    index = this.props.selectionModeSelections[i]['plan_rowIndex'];
                    if ((index != null) && (index >= 0)) {
                        this.planCircleRefs[index].current.setStyle(this.pathStyle(this.props.styleMap.Review_ClickedPrevious) || { fillOpacity: 1, fillColor: 'brown' })
                    }
                }
            }
        }

        this.setState({
            //Store
            pageCaptureClickedIndex: capturedataIndex,
            pageCaptureClickedData: capturedataData,
            pageMissingClickedIndex: missingdataIndex,
            pageMissingClickedData: missingdataData,
            pagePlanClickedIndex: plandataIndex,
            pagePlanClickedData: plandataData,
            pageCaptureShowPolyline: showPolyline,
            pageCaptureShowPolyline_Latitude1: lat1,
            pageCaptureShowPolyline_Longitude1: long1,
            pageCaptureShowPolyline_Latitude2: lat2,
            pageCaptureShowPolyline_Longitude2: long2,
        });
    }

    overrideColorsForUnassign(capturedataId) {

        //Mark clicked black
        if (capturedataId >= 0) {

            var diffdataindex = this.props.diffdata.findIndex((row) => row.CaptureId == capturedataId);

            if (diffdataindex > -1) {
                var diffRemoved = this.state.pageDiffRemoved
                diffRemoved[diffdataindex] = true;
                this.setState({
                    pageDiffRemoved: diffRemoved,
                });
            }
        }
    }

    clickEventCapture(e) {
        if (this.props.selectionModeEnabled && this.props.unassignModeEnabled) {
            this.clickEventCaptureUnassign(e);
            return;
        }
        if (this.props.selectionModeEnabled && !this.props.unassignModeEnabled) {
            console.log('capture marker clicked', e.target.options.rowData); // logs position.
            if (e.target.options.rowIndex != null) {
                ///Check if already selected
                var alreadySelected = false
                var index;
                for (var i = 0; i < this.props.selectionModeSelections.length; i++) {
                    index = this.props.selectionModeSelections[i]['capture_rowIndex'];
                    if ((index != null) && (index >= 0)) {
                        if (e.target.options.rowIndex == index) {
                            //match found - no valid hole selected
                            alreadySelected = true;
                            break;
                        }
                    }
                }
                if (!alreadySelected) {
                    if (!this.state.pageResetNextClick) {
                        //Have both clicks - store in props
                        if (this.state.pageMissingClickedIndex >= 0) {
                            this.props.selectionModeUpdate({
                                'capture_rowIndex': e.target.options.rowIndex,
                                'capture_rowData': e.target.options.rowData,
                                'missing_rowIndex': this.state.pageMissingClickedIndex,
                                'missing_rowData': this.state.pageMissingClickedData,
                            });
                        } else if (this.state.pagePlanClickedIndex >= 0) {
                            this.props.selectionModeUpdate({
                                'capture_rowIndex': e.target.options.rowIndex,
                                'capture_rowData': e.target.options.rowData,
                                'plan_rowIndex': this.state.pagePlanClickedIndex,
                                'plan_rowData': this.state.pagePlanClickedData,
                            });
                        }
                    }
                    if (this.state.pageResetNextClick) {
                        const prevCapIdx = this.state.pageCaptureClickedIndex;
                        if (this.state.pageMissingClickedIndex >= 0 || this.state.pagePlanClickedIndex >= 0) {
                            const polyline = [...this.state.pageCaptureShowPolyline];
                            if (prevCapIdx >= 0) polyline[prevCapIdx] = false;
                            this.setState({ pageCaptureShowPolyline: polyline });
                        }

                        const capIdx = e.target.options.rowIndex;
                        const capData = e.target.options.rowData;

                        this.setState({
                            pageResetNextClick: false,
                            pageCaptureClickedIndex: -1,
                            pageCaptureClickedData: {},
                            pageMissingClickedIndex: -1,
                            pageMissingClickedData: {},
                            pagePlanClickedIndex: -1,
                            pagePlanClickedData: {}
                        }, () => {
                            // treat this same click as the first of the next pair
                            this.overrideColorsForSelection(capIdx, capData, -1, {}, -1, {});
                        });

                        return;
                    }
                    if (this.state.pageMissingClickedIndex >= 0 || this.state.pagePlanClickedIndex >= 0) {
                        this.setState({
                            pageResetNextClick: true
                        });
                    }
                    this.overrideColorsForSelection(e.target.options.rowIndex, e.target.options.rowData, this.state.pageMissingClickedIndex, this.state.pageMissingClickedData, this.state.pagePlanClickedIndex, this.state.pagePlanClickedData);
                }
            }
        }
    }

    // Hole-side unassign (clickEventPlan, below) only ever emits the hole's REPORTED
    // capture id (row.AssocCaptureId). Under many-to-one hole assignment, other captures
    // assigned to that hole (no Summary.DiffvsPlan row, therefore no polyline) never
    // surface in that payload, so they were unreachable for unassign. This method lets
    // the operator unassign the clicked capture directly, keyed on its own capture id.
    clickEventCaptureUnassign(e) {
        var rowData = e.target.options.rowData;
        if (rowData == null) {
            return;
        }
        var captureId = rowData.Id != null ? rowData.Id : rowData.id;
        if (captureId == null) {
            return;
        }
        if (!rowData.Assigned) {
            //Not assigned - nothing to unassign
            return;
        }

        ///Check if already selected
        var alreadySelected = false;
        var selections = this.props.selectionModeSelections || [];
        for (var i = 0; i < selections.length; i++) {
            if (selections[i]['capture_rowData']?.Id == captureId) {
                //match found - already queued for unassign
                alreadySelected = true;
                break;
            }
        }
        if (alreadySelected) {
            return;
        }

        this.props.selectionModeUpdate({
            'capture_rowIndex': -1,
            'capture_rowData': { Id: captureId },
            'missing_rowIndex': -1,
            'missing_rowData': { PlanDetailsId: -999 },
        });

        this.overrideColorsForUnassign(captureId);
    }

    clickEventPlan(e) {
        if (this.props.selectionModeEnabled) {
            console.log('plan marker clicked', e.target.options.rowData); // logs position.
            if (e.target.options.rowIndex != null) {
                ///Check if already selected
                var alreadySelected = false
                var index;
                for (var i = 0; i < this.props.selectionModeSelections.length; i++) {
                    index = this.props.selectionModeSelections[i]['missing_rowIndex'];
                    if ((index != null) && (index >= 0)) {
                        if (e.target.options.rowIndex == index) {
                            //match found - no valid hole selected
                            alreadySelected = true;
                            break;
                        }
                    }
                }
                if (!alreadySelected) {
                    if (this.props.unassignModeEnabled) {
                        if (!this.state.pageResetNextClick) {
                            //Have both clicks - store in props
                            this.props.selectionModeUpdate({
                                'capture_rowIndex': -1,
                                'capture_rowData': { Id: e.target.options.rowData.AssocCaptureId },
                                'missing_rowIndex': -1,
                                'missing_rowData': { PlanDetailsId: -999 },
                            });

                            this.overrideColorsForUnassign(e.target.options.rowData.AssocCaptureId);
                        }
                    } else if (this.props.allowRemeasurement) {
                        if ((this.state.pageCaptureClickedIndex >= 0) && !this.state.pageResetNextClick) {
                            //Have both clicks - store in props
                            this.props.selectionModeUpdate({
                                'capture_rowIndex': this.state.pageCaptureClickedIndex,
                                'capture_rowData': this.state.pageCaptureClickedData,
                                'plan_rowIndex': e.target.options.rowIndex,
                                'plan_rowData': e.target.options.rowData,
                            });
                        }
                        //Check for reset first
                        if (this.state.pageResetNextClick) {
                            const prevCapIdx = this.state.pageCaptureClickedIndex;
                            if (this.state.pageMissingClickedIndex >= 0 || this.state.pagePlanClickedIndex >= 0) {
                                const polyline = [...this.state.pageCaptureShowPolyline];
                                if (prevCapIdx >= 0) polyline[prevCapIdx] = false;
                                this.setState({ pageCaptureShowPolyline: polyline });
                            }

                            const planIdx = e.target.options.rowIndex;
                            const planData = e.target.options.rowData;

                            this.setState({
                                pageResetNextClick: false,
                                pageCaptureClickedIndex: -1,
                                pageCaptureClickedData: {},
                                pageMissingClickedIndex: -1,
                                pageMissingClickedData: {},
                                pagePlanClickedIndex: -1,
                                pagePlanClickedData: {}
                            }, () => {
                                // treat this same click as the first of the next pair
                                this.overrideColorsForSelection(-1, {}, -1, {}, planIdx, planData);
                            });

                            return;
                        }
                        if (this.state.pageCaptureClickedIndex >= 0) {
                            this.setState({
                                pageResetNextClick: true
                            });
                        }
                        this.overrideColorsForSelection(this.state.pageCaptureClickedIndex, this.state.pageCaptureClickedData, this.state.pageMissingClickedIndex, this.state.pageMissingClickedData, e.target.options.rowIndex, e.target.options.rowData);
                    }
                }
            }
        }
    }

    clickEventMissing(e) {
        if (this.props.selectionModeEnabled && !this.props.unassignModeEnabled) {
            console.log('plan marker clicked', e.target.options.rowData); // logs position.
            if (e.target.options.rowIndex != null) {
                ///Check if already selected
                var alreadySelected = false
                var index;
                for (var i = 0; i < this.props.selectionModeSelections.length; i++) {
                    index = this.props.selectionModeSelections[i]['missing_rowIndex'];
                    if ((index != null) && (index >= 0)) {
                        if (e.target.options.rowIndex == index) {
                            //match found - no valid hole selected
                            alreadySelected = true;
                            break;
                        }
                    }
                }
                if (!alreadySelected) {
                    if ((this.state.pageCaptureClickedIndex >= 0) && !this.state.pageResetNextClick) {
                        //Have both clicks - store in props
                        this.props.selectionModeUpdate({
                            'capture_rowIndex': this.state.pageCaptureClickedIndex,
                            'capture_rowData': this.state.pageCaptureClickedData,
                            'missing_rowIndex': e.target.options.rowIndex,
                            'missing_rowData': e.target.options.rowData,
                        });
                    }
                    //Check for reset first
                    if (this.state.pageResetNextClick) {
                        const prevCapIdx = this.state.pageCaptureClickedIndex;
                        if (this.state.pageMissingClickedIndex >= 0 || this.state.pagePlanClickedIndex >= 0) {
                            const polyline = [...this.state.pageCaptureShowPolyline];
                            if (prevCapIdx >= 0) polyline[prevCapIdx] = false;
                            this.setState({ pageCaptureShowPolyline: polyline });
                        }

                        const missIdx = e.target.options.rowIndex;
                        const missData = e.target.options.rowData;

                        this.setState({
                            pageResetNextClick: false,
                            pageCaptureClickedIndex: -1,
                            pageCaptureClickedData: {},
                            pageMissingClickedIndex: -1,
                            pageMissingClickedData: {},
                            pagePlanClickedIndex: -1,
                            pagePlanClickedData: {}
                        }, () => {
                            // treat this same click as the first of the next pair
                            this.overrideColorsForSelection(-1, {}, missIdx, missData, -1, {});
                        });

                        return;
                    }
                    if (this.state.pageCaptureClickedIndex >= 0) {
                        this.setState({
                            pageResetNextClick: true
                        });
                    }
                    this.overrideColorsForSelection(this.state.pageCaptureClickedIndex, this.state.pageCaptureClickedData, e.target.options.rowIndex, e.target.options.rowData, this.state.pagePlanClickedIndex, this.state.pagePlanClickedData);
                }
            }
        }
    }

    createbounds(data) {
        var findindex = 0;
        for (var i = 0; i < data.length; i++) {
            if (data[i].Latitude != 0 && data[i].Longitude != 0) {
                findindex = i;
                break;
            }
        }
        return findindex;
    }

    extendbounds(data, bounds) {
        data.map(row => {
            if (row.Latitude != 0 && row.Longitude != 0) {
                //Valid GPS locatiosn only
                bounds.extend([row.Latitude, row.Longitude])
            }
        })
        if (data.length == 1) {
            bounds.extend([data[0].Latitude + 0.001, data[0].Longitude + 0.001]) //to not have single latlong other the extend function crashes
        }
        if (!bounds.isValid()) { //is bounds not valid, put generic (to stop map crashing)
            bounds.extend([0.001, 0.001]);
            bounds.extend([-0.001, -0.001]);
        }
    }

    // Strip radius from style objects so setStyle doesn't overwrite the marker's radius
    pathStyle(style) {
        if (!style) return style;
        const { radius, ...rest } = style;
        return rest;
    }

    // Makes a thicker ring without changing outer diameter
    dotVisual(markerRadius, weight = 2.25) {
        const w = Math.min(weight, Math.max(1.25, markerRadius * 0.35));
        const r = Math.max(2, Math.round(markerRadius - w / 2));
        return { r, w };
    }

    render() {
        var findindex;
        var data;
        if (this.props.capturedataLoaded) {
            findindex = this.createbounds(this.props.capturedata);
            data = this.props.capturedata;

        }
        if (this.props.plandataLoaded) {
            findindex = this.createbounds(this.props.plandata);
            data = this.props.plandata;
        }
        const center = [data[findindex].Latitude, data[findindex].Longitude]
        const bounds = latLngBounds(data[findindex].Latitude, data[findindex].Longitude)
        this.extendbounds(data, bounds);

        return (
            <div id="mapid">
                <MapContainer
                    center={center}
                    preferCanvas={true}
                    attributionControl={false}
                    scrollWheelZoom={true}
                    style={{ height: "100%", width: "100%" }}
                    bounds={bounds}
                    boundsOptions={{ padding: [10, 10] }}
                    whenReady={(e) => {
                        const mapInstance = e.target;        // <-- this is the Leaflet map
                        console.log('[GPSMap] ready, zoom:', mapInstance.getZoom());

                        this.props.PDFref.current = mapInstance;
                        this.map = mapInstance;

                        // initial radius based on the zoom after fitBounds
                        const z = mapInstance.getZoom();
                        const r = this.computeRadius(z);
                        this._lastZoom = z;
                        this._lastRadius = r;
                        console.log('[GPSMap] initial radius:', r);
                        this.setState({ markerRadius: r });

                        // listen for continuous zoom changes (smoother than zoomend)
                        mapInstance.on('zoom', this.handleZoom);
                    }}
                >
                    <LayersControl position="topright">
                        {this.props.tilelayerenabled &&
                            <LayersControl.BaseLayer name="Satellite">
                                <TileLayer maxNativeZoom={17} maxZoom={100}
                                    attribution='Powered by<a href="https://www.esri.com/">ESRI</a>'
                                    url={"https://ibasemaps-api.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}?token=" + window._env_.REACT_APP_ESRIMAP_CLIENTAPIKEY}
                                />
                            </LayersControl.BaseLayer>
                        }
                        {this.props.tilelayerenabled &&
                            <LayersControl.BaseLayer name="Map">
                                <TileLayer maxNativeZoom={18} maxZoom={100}
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                            </LayersControl.BaseLayer>
                        }
                        {this.props.tilelayerenabled &&
                            <LayersControl.BaseLayer checked name="None">
                                <TileLayer maxNativeZoom={18} maxZoom={100}
                                    attribution=''
                                    url=""
                                />
                            </LayersControl.BaseLayer>
                        }
                        <LayersControl.Overlay checked name="Plan">
                            <FeatureGroup pathOptions={{ color: this.props.styleMap?.HoleData_Plan && this.props.styleMap.HoleData_Plan.color || 'grey' }}>
                                {this.props.plandataLoaded && (this.props.plandata.length == this.planCircleRefs.length) &&
                                    this.props.plandata.map((row, index) => {
                                        if (!(row.Latitude != 0 && row.Longitude != 0)) return <div key={`plan-empty-${index}`}></div>;
                                        const { r, w } = this.dotVisual(this.state.markerRadius, 2.25);
                                        const planColor =
                                            (this.props.styleMap?.HoleData_Plan &&
                                                this.props.styleMap.HoleData_Plan.color) || 'grey';

                                        const basePlanStyle = {
                                            stroke: true,
                                            color: planColor,        
                                            weight: w,
                                            fillColor: planColor,
                                            fillOpacity: 0.35,
                                        };

                                        return (
                                            <div key={`plan-${index}`}>
                                                <CircleMarker
                                                    center={[row.Latitude, row.Longitude]}
                                                    radius={r}
                                                    rowData={row}
                                                    rowIndex={index}
                                                    eventHandlers={{
                                                        click: (e) => this.clickEventPlan(e),
                                                        mouseover: (e) =>
                                                            e.target.setStyle({
                                                                ...basePlanStyle,
                                                                color: 'rgba(17,24,39,0.55)',
                                                                fillOpacity: 0.55,
                                                            }),
                                                        mouseout: (e) => e.target.setStyle(basePlanStyle),
                                                    }}
                                                    ref={(ref) => {
                                                        this.planCircleRefs[index].current = ref;
                                                    }}
                                                    pathOptions={basePlanStyle}
                                                >
                                                    <Tooltip>
                                                        <div>
                                                            <h5>ID: {row.AssocPlanDetailsHoleId}</h5>
                                                            {row.AssocCaptureId !== -1 && <>
                                                                {this.props.showAdvanced && <h5>Capture ID: {row.AssocCaptureId}</h5>}
                                                                <h5>Capture Depth Diff (m): {row.AssocCaptureDepthDiff.toFixed(2)}</h5>
                                                                <h5>Capture XY Diff (m): {row.AssocCaptureDistDiff.toFixed(2)}</h5>
                                                            </>}
                                                        </div>
                                                    </Tooltip>
                                                </CircleMarker>
                                            </div>
                                        );
                                    })}
                            </FeatureGroup>
                        </LayersControl.Overlay>
                        <LayersControl.Overlay checked name="Missing">
                            <FeatureGroup pathOptions={{ color: this.props.styleMap?.HoleData_Missing && this.props.styleMap.HoleData_Missing.color || 'red' }}>
                                {this.props.missingdataLoaded && (this.props.missingdata.length == this.missingCircleRefs.length) &&
                                    this.props.missingdata.map((row, index) => {
                                        if (!(row.Latitude != 0 && row.Longitude != 0)) return <div key={`miss-empty-${index}`}></div>;
                                        const { r, w } = this.dotVisual(this.state.markerRadius, 2.25);
                                        const missingColor =
                                            (this.props.styleMap?.HoleData_Missing &&
                                                this.props.styleMap.HoleData_Missing.color) || 'red';

                                        const baseMissingStyle = {
                                            stroke: true,
                                            color: missingColor,          
                                            weight: w,
                                            fillColor: missingColor,
                                            fillOpacity: 0.35,
                                        };
                                        return (
                                            <div key={`miss-${index}`}>
                                                <CircleMarker
                                                    center={[row.Latitude, row.Longitude]}
                                                    radius={r}
                                                    rowData={row}
                                                    rowIndex={index}
                                                    eventHandlers={{
                                                        click: (e) => this.clickEventMissing(e),
                                                        mouseover: (e) =>
                                                            e.target.setStyle({
                                                                ...baseMissingStyle,
                                                                color: 'rgba(17,24,39,0.55)',
                                                                fillOpacity: 0.55,
                                                            }),
                                                        mouseout: (e) => e.target.setStyle(baseMissingStyle),
                                                    }}
                                                    ref={(ref) => {
                                                        this.missingCircleRefs[index].current = ref;
                                                    }}
                                                    pathOptions={baseMissingStyle}
                                                >
                                                    <Tooltip>
                                                        <div>
                                                            <h5>ID: {row.Name}</h5>
                                                        </div>
                                                    </Tooltip>
                                                </CircleMarker>
                                            </div>
                                        );
                                    })}
                            </FeatureGroup>
                        </LayersControl.Overlay>
                        <LayersControl.Overlay checked name="Diff">
                            <FeatureGroup>
                                {this.props.diffdataLoaded && (this.props.diffdata.length == this.diffCircleRefs.length) &&
                                    this.props.diffdata.map((row, index) => {
                                        if (!(row.Latitude_Plan != 0 && row.Longitude_Plan != 0 && row.Latitude_Capture != 0 && row.Longitude_Capture != 0))
                                            return <div key={`diff-empty-${index}`}></div>;
                                        const { r: diffR, w: diffW } = this.dotVisual(this.state.markerRadius, 2.25);
                                        const diffColor = this.state.pageDiffRemoved[index] && 'red' || this.props.styleMap?.Review_Diff && this.props.styleMap.Review_Diff.color || 'orange';
                                        return (
                                            <div key={`diff-${index}`}>
                                                <CircleMarker center={[row.Latitude_Capture, row.Longitude_Capture]} radius={diffR} pathOptions={{ stroke: true, color: diffColor, weight: diffW, fillColor: diffColor, fillOpacity: 0.55 }} ref={(ref) => { this.diffCircleRefs[index].current = ref; }}>
                                                    <Tooltip>
                                                        <div>
                                                            <h5>ID: {row.Name}</h5>
                                                            <h5>Depth Diff (m): {row.Diff_HoleDepth.toFixed(2)}</h5>
                                                            <h5>XY Diff (m): {row.Diff_Dist.toFixed(2)}</h5>
                                                            <h5>Depth Measured (m): {row.HoleLength_Capture.toFixed(2)}</h5>
                                                        </div>
                                                    </Tooltip>
                                                </CircleMarker>
                                                <Polyline positions={[[row.Latitude_Plan, row.Longitude_Plan], [row.Latitude_Capture, row.Longitude_Capture]]} pathOptions={{ color: this.state.pageDiffRemoved[index] && 'red' || row.CalculationType == "Override" && '#ff00e6' || (this.props.styleMap?.Review_Diff && this.props.styleMap.Review_Diff.color || 'orange'), weight: this.state.pageDiffRemoved[index] && 5 }} ref={(ref) => { this.diffPolylineRefs[index].current = ref; }} />
                                            </div>
                                        );
                                    })}
                            </FeatureGroup>
                        </LayersControl.Overlay>
                        <LayersControl.Overlay checked name="Captures">
                            <FeatureGroup>
                                {this.props.capturedataLoaded && (this.props.capturedata.length == this.captureCircleRefs.length) &&
                                    this.props.capturedata.map((row, index) => {
                                        if (!(row.Latitude != 0 && row.Longitude != 0)) return <div key={`cap-empty-${index}`}></div>;
                                        const { r, w } = this.dotVisual(this.state.markerRadius, 2.25);
                                        const captureId = row.Id != null ? row.Id : row.id;
                                        const captureReported = (this.props.diffdata || []).findIndex((d) => d.CaptureId == captureId) > -1;
                                        const captureOrphaned = row.Assigned && this.props.diffdataLoaded && !captureReported;
                                        // overrideColorsForUnassign only reddens a diffdata polyline, and an orphan
                                        // has none — so queued unassigns are read off selectionModeSelections here
                                        // instead. Render-driven rather than a setStyle call because the marker's
                                        // mouseout handler resets to baseCaptureStyle and would wipe an imperative one.
                                        const captureUnassignQueued = (captureId != null) &&
                                            (this.props.selectionModeSelections || []).some((sel) =>
                                                sel?.missing_rowData?.PlanDetailsId == -999 &&
                                                sel?.capture_rowData?.Id == captureId);
                                        const captureFillColor =
                                            captureUnassignQueued
                                                ? (this.props.styleMap?.Review_Clicked &&
                                                    this.props.styleMap.Review_Clicked.color) || 'black'
                                                : (row.Assigned && this.props.selectionModeEnabled && captureOrphaned)
                                                    ? ORPHAN_CAPTURE_COLOR
                                                    : (row.Assigned && this.props.selectionModeEnabled)
                                                        ? '#c9c9c9'
                                                        : (this.props.styleMap?.HoleData_Captured &&
                                                            this.props.styleMap.HoleData_Captured.color) || 'green';

                                        const baseCaptureStyle = {
                                            stroke: true,
                                            color: captureFillColor,    
                                            weight: w,
                                            fillColor: captureFillColor,
                                            fillOpacity: 0.55,
                                        };

                                        return (
                                            <div key={`cap-${index}`}>
                                                <CircleMarker
                                                    center={[row.Latitude, row.Longitude]}
                                                    radius={r}
                                                    rowData={row}
                                                    rowIndex={index}
                                                    eventHandlers={{
                                                        click: (e) => this.clickEventCapture(e),
                                                        mouseover: (e) =>
                                                            e.target.setStyle({
                                                                ...baseCaptureStyle,
                                                                color: 'rgba(17,24,39,0.55)',
                                                                fillOpacity: 0.55,
                                                            }),
                                                        mouseout: (e) => e.target.setStyle(baseCaptureStyle),
                                                    }}
                                                    ref={(ref) => {
                                                        this.captureCircleRefs[index].current = ref;
                                                    }}
                                                    pathOptions={baseCaptureStyle}
                                                >

                                                    <Tooltip>
                                                        <div>
                                                            {this.props.showAdvanced && <><h5>Capture ID: {row.id}</h5>
                                                                <h5>Toe RL(m): {JSON.parse(row.data).toerl.toFixed(2)}</h5>
                                                                <h5>Reflectivity(%): {row.reflecthole_data.toFixed(2)}</h5>
                                                                <h5>Points Collected: {JSON.parse(row.data).pointcount}</h5></>}
                                                            <h5>Assigned: {row.Assigned ? (captureOrphaned ? "Yes (not reported)" : "Yes") : "No"}</h5>
                                                            <h5>DateTime: {row.dateTimeLocalString}</h5>
                                                            <h5>Depth Measured (m): {(row.depthhole_rounded / 1000).toFixed(2)}</h5>
                                                            <h5>Capture Type: {row.capturetype_data}</h5>
                                                        </div>
                                                    </Tooltip>
                                                </CircleMarker>
                                            </div>
                                        );
                                    })}
                            </FeatureGroup>
                            {this.props.selectionModeEnabled &&
                                <FeatureGroup pathOptions={{ color: this.props.styleMap?.Review_Polyline && this.props.styleMap.Review_Polyline.color || 'black', weight: 5 }}>
                                    {this.props.capturedataLoaded && (this.props.capturedata.length == this.capturePolylineRefs.length) &&
                                        this.props.capturedata.map((row, index) =>
                                            row.Latitude != 0 && row.Longitude != 0 ?
                                                <div key={`capline-${index}`}>
                                                    {(this.state.pageCaptureShowPolyline[index]) &&
                                                        <Polyline positions={[[this.state.pageCaptureShowPolyline_Latitude1[index], this.state.pageCaptureShowPolyline_Longitude1[index]], [this.state.pageCaptureShowPolyline_Latitude2[index], this.state.pageCaptureShowPolyline_Longitude2[index]]]} ref={(ref) => { this.capturePolylineRefs[index].current = ref; }} />
                                                    }
                                                </div>
                                                : <div key={`capline-empty-${index}`}></div>
                                        )}
                                </FeatureGroup>
                            }
                        </LayersControl.Overlay>
                    </LayersControl>
                </MapContainer>
            </div>
        );
    }
}